import Vue from 'vue';
import Vuex from 'vuex';

import { account } from '@shared/_store/account.module';
import { media } from '@shared/_store/media.module';
import { usersManagement } from './usersManagement.module';
import { rolesManagement } from './rolesManagement.module';
import { resourcesManagement } from './resourcesManagement.module';
import { diamondManagement } from './diamondManagement.module';
import { categoryManagement } from './shop/categoryManagement.module';
import { content } from './admin/content/content.module';
import { category } from './admin/category.module';
import { article } from './shop/article.module';
import { shopContent } from './shop/content.module';
import {error} from "./shop/error.module";
import {cart} from "./shop/cart.module";
import {sample} from "./shop/sample.module";
import {favorites} from "./shop/favorites.module";
import {modal} from "./modal.module";
Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        account,
        media,
        usersManagement,
        rolesManagement,
        resourcesManagement,
        diamondManagement,
        categoryManagement,
        content,
        category,
        article,
        shopContent,
        error,
        cart,
        sample,
        favorites,
        modal
    }
});